import { render } from "./Faqs.html?vue&type=template&id=7e14effc&ts=true"
import script from "./Faqs.vue?vue&type=script&lang=ts"
export * from "./Faqs.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devgeorge/andrea/webpage_curaduria2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__